<div class="d-flex align-items-center">
  <div class="" style="width: 300px;">
    <ng-container>
      <ng-select
        class="form-control"
        [formControl]="period"
        [items]="periods"
        bindLabel="period"
        placeholder="{{ 'timefilter_dates_choose' | translate }}"
        (change)="onSelectionChange($event)"
      ></ng-select>
    </ng-container>
  </div>
  <span class="ms-5" translate>common_from</span>
  <wsb-atlas-datepicker [formControl]="dateFrom" [max]="dateTo.value ? dateTo.value : today" class="ms-3"></wsb-atlas-datepicker>
  <span class="ms-5" translate>common_to</span>
  <wsb-atlas-datepicker [min]="dateFrom.value" [max]="today" class="ms-3" [formControl]="dateTo"></wsb-atlas-datepicker>
  <wsb-atlas-button
    class="ms-5"
    [label]="'common_search'"
    [disabled]="!dateFrom.value || !dateTo.value"
    [variant]="'primary'"
    (click)="search()"
  >
  </wsb-atlas-button>
</div>

<div class="row mt-5">
  <div class="col-6 col-lg-3 mb-4">
    <wsb-ui-card title="{{ 'stats_pages_details_views_total' | translate }}" type="choice_card_a">
      <div class="text-center" wsb-ui-card-footer>
        <span class="number">{{ pageVisitsByDay?.visits?.total ? pageVisitsByDay.visits.total : 0 }}</span>
      </div>
    </wsb-ui-card>
  </div>
  <div class="col-6 col-lg-3 mb-4">
    <wsb-ui-card title="{{ 'stats_pages_details_views_days' | translate }}" type="choice_card_a">
      <div class="text-center" wsb-ui-card-footer>
        <span class="number">{{ pageVisitsByDay?.visits?.average ? pageVisitsByDay.visits.average : 0 }}</span>
      </div>
    </wsb-ui-card>
  </div>
  <div class="col-6 col-lg-3 mb-4">
    <wsb-ui-card title="{{ 'stats_pages_details_unique_views_total' | translate }}" type="choice_card_a">
      <div class="text-center" wsb-ui-card-footer>
        <span class="number">{{ pageVisitsByDay?.uniqueVisits?.total ? pageVisitsByDay.uniqueVisits.total : 0 }}</span>
      </div>
    </wsb-ui-card>
  </div>
  <div class="col-6 col-lg-3 mb-4">
    <wsb-ui-card title="{{ 'stats_pages_details_views_days' | translate }}" type="choice_card_a">
      <div class="text-center" wsb-ui-card-footer>
        <span class="number">{{ pageVisitsByDay?.uniqueVisits?.average ? pageVisitsByDay.uniqueVisits.average : 0 }}</span>
      </div>
    </wsb-ui-card>
  </div>
</div>

<div class="d-flex w-100">
  <div class="mt-5 w-50">
    <div class="w-100" style="display: block;">
      <canvas
        baseChart
        width="400"
        height="350"
        *ngIf="lineChartPerDayOptions"
        [datasets]="pageVisitsByDayData"
        [labels]="pageVisitsByDay?.visits?.labels"
        [options]="lineChartPerDayOptions"
        [legend]="lineChartPerDayLegend"
        [type]="lineChartPerDayType"
      >
      </canvas>
    </div>
  </div>

  <div class="mt-5 w-50">
    <div class="w-100" style="display: block;">
      <canvas
        baseChart
        width="400"
        height="350"
        *ngIf="lineChartPerDayOptions"
        [datasets]="pageUniqueVisitsByDayData"
        [labels]="pageVisitsByDay?.uniqueVisits?.labels"
        [options]="lineChartPerDayOptions"
        [legend]="lineChartPerDayLegend"
        [type]="lineChartPerDayType"
      >
      </canvas>
    </div>
  </div>
</div>
